module.exports = "<ng-container *ngIf=\"brandMatch\">\n\t<ng-content></ng-content>\n</ng-container>"